import serviceProject from "../serviceProject";

const TariffPeriod = {
  ...serviceProject,
  preList: function(params) {
    return `projects/${params.project_id || "-"}/tariffs/${params.tariff_id}`;
  },
  resource: "periods"
};
export default TariffPeriod;
